import { IntermediaryPaymentMethodsCard } from '@folio/components/features/payment/IntermediaryPaymentMethods';
import { loadStripe } from '@stripe/stripe-js';
import { useKorintModuleConfig } from 'korint-sdk/react';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

type IntermediaryPaymentMethodModuleProps = {
  readonly?: boolean;
  showMandateSignatureButton?: boolean;
};

export function IntermediaryPaymentMethodModule({
  readonly,
  showMandateSignatureButton,
}: IntermediaryPaymentMethodModuleProps) {
  const methodPayment = useKorintModuleConfig('methodPayment');

  const { brokerageFirmId } = useParams();

  const stripePromise = useMemo(() => {
    if (!methodPayment.stripePublishableKey) {
      throw new Error('Stripe publishable key has not been set');
    }
    return loadStripe(methodPayment.stripePublishableKey);
  }, [methodPayment.stripePublishableKey]);

  return (
    <IntermediaryPaymentMethodsCard
      brokerageFirmId={brokerageFirmId!}
      stripePromise={stripePromise}
      readonly={readonly}
      showMandateSignatureButton={showMandateSignatureButton}
      canBeDefault={paymentMethod => paymentMethod.paymentMethodType === 'sepa_debit'}
    />
  );
}
